// Invite rewards, client side (the rules and the counting live on the server: server.js "Invite rewards").
// The server issues this install's player id + secret on first use; the relay transport sends them after joining a
// room so the server can count your online matches. Everything here only asks the server; nothing is counted locally.

const KEY = 'slimeduel.invite';

/** What inviting friends earns (a display copy of server.js REF_TIERS, shown before / without the server's answer;
 *  the server's own list wins and is the only one that pays out). */
export const INVITE_TIERS = [
  { n: 1, reward: { type: 'gems', n: 100 } },
  { n: 2, reward: { type: 'crate', n: 1 } },
  { n: 3, reward: { type: 'item', id: 'tag_squadup' } },
  { n: 5, reward: { type: 'item', id: 'plate_crew' } },
  { n: 10, reward: { type: 'gems', n: 300, crates: 1 } },
];
export const INVITE_WELCOME = { type: 'gems', n: 100 };
const base = () => (typeof location !== 'undefined' ? location.origin : '');

function load() {
  try { const v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && v.pid && v.secret ? v : null; } catch { return null; }
}

/** This install's invite identity if it has one already (no network). */
export const inviteId = () => load();

async function post(path, body) {
  const r = await fetch(base() + path, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body || {}) });
  let j = null;
  try { j = await r.json(); } catch { /* not our server */ }
  if (!r.ok || !j || !j.ok) { const e = new Error((j && j.error) || 'invite service unavailable'); e.status = r.status; throw e; }
  return j;
}

let registering = null;
/** The identity, registering this install with the server the first time. */
export async function ensureInviteId() {
  const have = load();
  if (have) return have;
  registering ||= post('/ref/register').then((j) => {
    const v = { pid: j.pid, secret: j.secret, code: j.code };
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch { /* private mode: try again next time */ }
    return v;
  }).finally(() => { registering = null; });
  return registering;
}

const auth = async () => { const v = await ensureInviteId(); return { pid: v.pid, secret: v.secret }; };
export const inviteStatus = async () => post('/ref/status', await auth());
export const enterInviteCode = async (code) => post('/ref/enter', { ...(await auth()), code });
export const redeemInvite = async (tier) => post('/ref/redeem', { ...(await auth()), tier });
/** Shop → REDEEM CODE: the server checks the code (codes never ship in the client) and says what it grants. */
export const redeemCode = async (code) => post('/codes/redeem', { ...(await auth()), code });

/** The relay frame that ties this connection to your id (src/net/transport.js sends it after the welcome). */
export function inviteAuthFrame() {
  const v = load();
  return v ? JSON.stringify({ t: 'auth', pid: v.pid, secret: v.secret }) : null;
}
